import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import {
    fetchMenuItems,
    fetchMenuClasses,
    fetchMenus
} from './thunks';
import {updateMenuItemsTreeData} from './actions';
import {getFilteredDataById} from '../../components/helpers/helpers';
import MenuViewTree from './MenuViewTree';

class MenuView extends Component {

    componentWillMount() {
        this.props.fetchMenuItems(this.props.match.params.id);
        this.props.fetchMenuClasses();
        this.props.fetchMenus();
    }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    render() {

        const menuId = Number(this.props.match.params.id);
        let menuData = getFilteredDataById(this.props.menus, menuId)

        return (
            menuData !== undefined && this.props.loading !== true &&
            <div>
                <MenuViewTree
                    menuItemsTreeData={this.props.menuItemsTreeData}
                    menuClasses={this.props.menuClasses}
                    menuType={menuData.type.name}
                    menuSite={menuData.site.name}
                    classes={this.props.classes}
                    updateMenuItemsTreeData={this.props.updateMenuItemsTreeData}
                    loading={this.props.loading}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    menuItemsTreeData: state.menus.menuItemsTreeData,
    menuClasses: state.menus.menuClasses,
    menus: state.menus.all,
    loading: state.layout.ajaxCallsInProgress > 0,
});

export default connect(mapStateToProps, {
    fetchMenuItems,
    fetchMenuClasses,
    fetchMenus,
    updateMenuItemsTreeData
})(withStyles(styles)(MenuView));




// WEBPACK FOOTER //
// ./src/containers/menus/MenuView.jsx